import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';

import { Icon } from '../../shared/Icon';
import { PortalPublication } from '../PortalPublication';

import styles from './Category.module.scss';

interface DeleteCategoryModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    categoryName?: string;
    activeToday: PortalPublication[];
    futurePublications: PortalPublication[];
    uniqueFutureDays: string[];
}

export const DeleteCategoryModal = ({
    open,
    onCancel,
    onConfirm,
    categoryName,
    activeToday,
    futurePublications,
    uniqueFutureDays,
}: DeleteCategoryModalProps) => (
    <Dialog open={open} onClose={onCancel} maxWidth="xs">
        <DialogTitle>Delete Category</DialogTitle>
        <DialogContent>
            {activeToday.length > 0 && (
                <>
                    <Box className={styles.backgroundBox}>
                        <Box className={styles.warningIconButton}>
                            <Icon
                                name="warning"
                                style={{
                                    color: '#CE1414',
                                    fontSize: 32,
                                }}
                            />
                        </Box>
                        <Box>
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: 'bold', display: 'inline' }}
                            >
                                This category has posts{' '}
                                <span style={{ textDecoration: 'underline' }}>
                                    live
                                </span>{' '}
                                in the publication feed.
                            </Typography>
                            <br />
                            <Typography
                                variant="body1"
                                sx={{ display: 'inline' }}
                            >
                                Deleting this category means it will be removed
                                from Portal, so that players can’t see it.
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <br />
                        <Typography variant="body1">
                            This category has{' '}
                            <b>
                                {uniqueFutureDays.length > 0
                                    ? uniqueFutureDays.length
                                    : activeToday.length > 0
                                      ? 1
                                      : 0}
                            </b>{' '}
                            publication days scheduled.
                        </Typography>
                        <br />
                        <Typography variant="body2">
                            Are you sure you want to delete {categoryName}?
                            <br />
                            <b>Deleted categories cannot be restored.</b>
                        </Typography>
                    </Box>
                </>
            )}
            {activeToday.length === 0 && futurePublications.length > 0 && (
                <>
                    <Box className={styles.backgroundBox}>
                        <Box className={styles.warningIconButton}>
                            <Icon
                                name="warning"
                                style={{
                                    color: '#FFA726',
                                    fontSize: 32,
                                }}
                            />
                        </Box>
                        <Box>
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: 'bold', display: 'inline' }}
                            >
                                This category has posts{' '}
                                <span style={{ textDecoration: 'underline' }}>
                                    scheduled
                                </span>{' '}
                                in the publication feed.
                            </Typography>
                            <br />
                            <Typography
                                variant="body1"
                                sx={{ display: 'inline' }}
                            >
                                Deleting this category means it will be removed
                                from Portal, so that players can’t see it.
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <br />
                        <Typography variant="body1">
                            This category has <b>{uniqueFutureDays.length}</b>{' '}
                            publication days scheduled.
                        </Typography>
                        <br />
                        <Typography variant="body2">
                            Are you sure you want to delete {categoryName}?
                            <br />
                            <b>Deleted categories cannot be restored.</b>
                        </Typography>
                    </Box>
                </>
            )}
            {activeToday.length === 0 && futurePublications.length === 0 && (
                <Box sx={{ bgcolor: 'grey.100', borderRadius: 2, p: 2, mt: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        There are no live or scheduled posts in this category.
                    </Typography>
                </Box>
            )}
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel} color="primary">
                Cancel
            </Button>
            <Button onClick={onConfirm} color="error" variant="contained">
                Yes
            </Button>
        </DialogActions>
    </Dialog>
);
